
import { Options, Vue } from 'vue-class-component';
import Wish from "@/classes/Wish";

@Options({
    props: {
        wish: Wish
    }
})
export default class WishCard extends Vue {
    public wish!: Wish;
    private milaImages = 5;
    private static usedImages: number[] = [];
    public get image(): string {
        return this.wish.image ? `/api/images/${this.wish.image}` : this.randomImage;
    }
    public get randomImage(): string {
        if (WishCard.usedImages.length == this.milaImages) {
            WishCard.usedImages = [];
        }
        let index;
        do {
            index = Math.floor(Math.random() * this.milaImages);
        } while (WishCard.usedImages.indexOf(index) != -1);
        WishCard.usedImages.push(index);
        return `/api/images/mila${index}.jpg`;
    }
    private numberText(num: number, text: string) {
        const result: string[] = [];
        result.push(num ? num.toString() : 'Ingen');
        result.push(num == 1 ? text : text + 'er');
        return result.join(' ');
    }
    public get commentText(): string {
        return this.numberText(this.wish.commentCount, 'kommentar');
    }
    public get reservertionText(): string {
        return this.numberText(this.wish.reservertions, 'reservertion');
    }
}
